import { Hub, BrowserClient, defaultIntegrations, makeMain } from '@sentry/browser';
import PaymentError from '../components/PaymentError/PaymentError.js';

let sentryService = null;
function getSentryService(env, defaultConfig) {
    if (sentryService === null) {
        const { appVersion, sentryDsn } = defaultConfig;
        sentryService = new SentryService(sentryDsn, env, appVersion);
    }
    else {
        sentryService.maybeReset(env);
    }
    return sentryService;
}
const captureException = (error, captureContext) => {
    return sentryService !== null
        ? sentryService.captureException(error, captureContext)
        : new PaymentError(error);
};
class SentryService {
    env = 'dev';
    appVersion;
    dsn;
    state = { status: 'UN_INITIALIZED' };
    errorQueue = [];
    constructor(dsn, env, appVersion) {
        this.env = env;
        this.dsn = dsn;
        this.appVersion = appVersion;
        this.initializeSentry();
    }
    initializeSentry = (whitelistUrls) => {
        try {
            const hub = new Hub(new BrowserClient({
                dsn: this.dsn,
                environment: this.env,
                integrations: [...defaultIntegrations],
                whitelistUrls,
            }));
            hub.configureScope((scope) => {
                scope.setTags({ version: this.appVersion });
            });
            makeMain(hub);
            this.state = {
                status: 'INITIALIZED',
                hub,
            };
        }
        catch (error) {
            this.errorQueue.push(error);
        }
    };
    processErrorQueue = (hub) => {
        this.errorQueue.forEach((error) => hub.captureException(error));
        this.errorQueue = [];
    };
    captureError(hub, sentryError, captureContext) {
        if (sentryError.error) {
            hub.configureScope((scope) => {
                if (captureContext) {
                    captureContext(scope);
                }
            });
            hub.captureException(sentryError.error);
        }
        else {
            const paymentError = new PaymentError(sentryError);
            hub.configureScope((scope) => {
                if (captureContext) {
                    captureContext(scope);
                }
            });
            hub.captureException(paymentError);
        }
    }
    captureException = (sentryError, captureContext) => {
        if (this.state.status === 'UN_INITIALIZED') {
            this.initializeSentry();
        }
        const isNotProdEnv = this.env !== 'prod';
        const paymentError = new PaymentError(sentryError);
        if (this.state.status === 'INITIALIZED') {
            this.processErrorQueue(this.state.hub);
            this.captureError(this.state.hub, sentryError, captureContext);
            if (isNotProdEnv) {
                const errorToLog = sentryError.error || paymentError;
                console.error(errorToLog);
            }
        }
        else {
            // If not initialized, add to error queue
            if (sentryError.error) {
                this.errorQueue.push(sentryError.error);
            }
            else {
                this.errorQueue.push(paymentError);
            }
        }
        return paymentError;
    };
    maybeReset(env) {
        if (this.env !== env) {
            const oldEnv = this.env;
            this.env = env;
            this.initializeSentry();
            this.captureException(new Error(`SentryService switch from environment ${oldEnv} to ${env}`));
        }
    }
}

export { captureException, SentryService as default, getSentryService };
//# sourceMappingURL=sentryService.js.map
